import PropTypes from 'prop-types';

import { DownloadIcon } from '@utilities';

const DownloadXLSX = ({ downloadFileUrl, downloadLabel }) => {
  return (
    <a data-testid="download-xlsx" href={downloadFileUrl}>
      <DownloadIcon />
      <span>.XLSX File - {downloadLabel || 'Entire Report'}</span>
    </a>
  );
};

DownloadXLSX.propTypes = {
  downloadFileUrl: PropTypes.string,
  downloadLabel: PropTypes.string,
};

export default DownloadXLSX;
